import { FC } from "react";
import styles from "./buttonCheckout.module.css";

const ButtonCheckout: FC<{
  action: any;
  label: string;
  backgroundColor: string;
  color: string;
  marginBottom?: boolean;
  disabled?: boolean;
}> = ({ label, action, color, backgroundColor, marginBottom, disabled = false }) => {
  return (
    <div
      className={styles.button}
      style={marginBottom ? { bottom: "5em" } : { bottom: "0em" }}
    >
      <button
        disabled={disabled}
        onClick={() => !disabled && action && action()}
        style={{
          backgroundColor: backgroundColor,
          color: color,
          opacity: disabled ? 0.7 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        {label}
      </button>
    </div>
  );
};

export { ButtonCheckout };
